export const RADIO_BUTTON_GROUP_DIRECTION = ["ltr", "rtl"] as const;
export type RadioButtonGroupDirection = (typeof RADIO_BUTTON_GROUP_DIRECTION)[number];
export const RADIO_BUTTON_GROUP_ORIENTATION = ["horizontal", "vertical"] as const;
export type RadioButtonGroupOrientation = (typeof RADIO_BUTTON_GROUP_ORIENTATION)[number];
